import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorksSection() {
  const steps = [{
    num: '01',
    text: "Aplica el 'Interruptor del Nervio Vago' 15 minutos antes de acostarte para bajar tus niveles de cortisol."
  }, {
    num: '02',
    text: "Configura tu 'Muro de Sonido' natural siguiendo las reglas de frecuencia y distancia del protocolo."
  }, {
    num: '03',
    text: 'Sigue el plan de 7 noches para que tu cerebro empiece a ignorar el ruido de forma automática.'
  }];
  return <section className="py-16 md:py-24 px-5 md:px-8 bg-[#0d1222] border-y border-[#1a1f3a]" data-id="element-64">
      <div className="max-w-4xl mx-auto" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-66">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-67">
            ¿Cómo funciona?
          </h2>
          <div className="w-24 h-1 bg-[#d4a853] mx-auto rounded-full" data-id="element-68"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-69">
          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} className="bg-[#1a1f3a] p-8 rounded-xl border border-[#2a3150] relative text-center" data-id="element-70">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-[#d4a853] text-[#0a0e1a] font-bold text-xl rounded-full flex items-center justify-center shadow-lg" data-id="element-71">
                {step.num}
              </div>
              <p className="text-gray-300 mt-6 leading-relaxed" data-id="element-72">{step.text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="mt-16 flex justify-center" data-id="element-73">
          <a href="#comprar" className="bg-[#d4a853] hover:bg-[#e5b964] text-[#0a0e1a] font-bold text-lg px-8 py-3.5 rounded-lg transition-all duration-300 shadow-[0_0_20px_rgba(212,168,83,0.3)] transform hover:scale-105 active:scale-95 flex items-center justify-center w-full md:w-auto" data-id="element-74">
            Ver Protocolo
          </a>
        </motion.div>
      </div>
    </section>;
}